import {UPLOAD_CABLE_UPDATING_FOTO_API_URL, GET_CABLE_UPDATING_FOTO_API_URL, DELETE_CABLE_UPDATING_FOTO_API_URL } from "../Optics/OpticApiConfig";

// Функция загрузки фото с сервера CABLE
export const loadCableUpdatingImagesFromServer = async (cableId, setServerImageUrls, setUploadMessage) => {
  const token = localStorage.getItem('token');
  if (!token) {
      console.log('Ошибка! Токен не найден');
      return;
  }
    try {
      const response = await fetch(`${GET_CABLE_UPDATING_FOTO_API_URL}?cableId=${cableId}`, { 
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}` 
        }
      });
  
      if (!response.ok) {
        throw new Error('Ошибка при загрузке файлов с сервера.');
      }
  
      const imageList = await response.json();
  
      if (imageList.length === 0) {
        setUploadMessage('Файлов не найдены.');
        setServerImageUrls([]);
        return;
      }
  
      const imageUrls = imageList.map(image => {
        const url = `data:${image.contentType};base64,${image.fileContent}`;
        return {
          url,
          fileName: image.fileName,
          street: image.street,  
          house:  image.house,
          entrance:  image.entrance,
          houseId: image.houseId, 
          authorId: image.authorId
        };
      });
  
      setServerImageUrls(imageUrls);
      setUploadMessage('');
    } catch (error) {
      setUploadMessage('Ошибка загрузки файлов с сервера: ' + error.message);
    }
  };


  // Функция для загрузки фото CABLE на сервер (МАКСИМУМУ ПО 10 шт)
export const uploadCableUpdatingImage = async (files, cableId, setFileName, setIsFileUploaded, setServerImageUrls, setUploadMessage, hid, entrance, user,  showSnackbar) => {
   
     const token = localStorage.getItem("token");
  if (!token) {
    console.log("Ошибка! Токен не найден");
    return;
  }

  const formData = new FormData();
files.forEach((file) => {
  formData.append("files", file); // ✅ "files" — как в C# List<IFormFile> files
});
  formData.append("cableId", cableId);
  formData.append("user", user);
  formData.append("hid", hid);
  formData.append("entrance", entrance);

  try {
    const response = await fetch(UPLOAD_CABLE_UPDATING_FOTO_API_URL, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const textResult = await response.text();
    try {
      const result = JSON.parse(textResult);
      if (response.ok) {
        showSnackbar(result.message, "snackbarOk");
        setUploadMessage(result.message);
        await loadCableUpdatingImagesFromServer(
          cableId,
          setServerImageUrls,
          setUploadMessage
        );
        setIsFileUploaded(true);
        setFileName(files.map((f) => f.name).join(", "));
      } else {
        setUploadMessage("Ошибка загрузки: " + result.message);
        showSnackbar(result.message, "snackbarWarning");
      }
    } catch (parseError) {
      setUploadMessage("Ошибка ответа сервера: " + textResult);
      showSnackbar(textResult, "snackbarWarning");
    }
  } catch (error) {
    setUploadMessage("Ошибка запроса: " + error.message);
    showSnackbar(error.message, "snackbarWarning");
  }
};


//   // Функция для загрузки фото Fob на сервер ПО ОДНОЙ ФОТО
// export const uploadCableUpdatingImage = async (file, cableId, setFileName, setIsFileUploaded, setServerImageUrls, setUploadMessage, hid, entrance, user,  showSnackbar) => {
   
//     const token = localStorage.getItem('token');
//       if (!token) {
//           console.log('Ошибка! Токен не найден');
//           return;
//       }

//     setFileName(file.name);
//     setIsFileUploaded(true);
  
//     const formData = new FormData();
//     formData.append('file', file);
//     formData.append('cableId', cableId);
//     formData.append('user', user);
//     formData.append('hid', hid);
//     formData.append('entrance', entrance);

   
  
//     try {
//       const response = await fetch(UPLOAD_CABLE_UPDATING_FOTO_API_URL, {
//         method: 'POST',
//         body: formData,
//         headers: {
//           'Authorization': `Bearer ${token}` 
//         }
//       });
  
//       const textResult = await response.text();
//       try {
//         const result = JSON.parse(textResult);
//         if (response.ok) {
//           showSnackbar(result.message, 'snackbarOk');
//           setUploadMessage(result.message);
  
//           // После успешной загрузки фото загружаем обновленный список изображений
//          await loadCableUpdatingImagesFromServer(cableId, setServerImageUrls, setUploadMessage);
//         } else {
//           setUploadMessage('Ошибка загрузки файла: ' + result.message);
//           showSnackbar(result.message, 'snackbarOk');
//         }
//       } catch (parseError) {
//         setUploadMessage('Ошибка загрузки файла: ' + textResult);
//         showSnackbar(textResult, 'snackbarOk');
//       }
//     } catch (error) {
//       setUploadMessage('Ошибка загрузки файла: ' + error.message);
//       showSnackbar(error.message, 'snackbarOk');

//     }
//   };


  // Функция для удаления фото Cable на сервере
export const deleteCableUpdateImage = async (fileName, cableId, setServerImageUrls, setUploadMessage, user) => {
  
  const token = localStorage.getItem('token');
      if (!token) {
          console.log('Ошибка! Токен не найден');
          return;
      }

    try {
      const response = await fetch(`${DELETE_CABLE_UPDATING_FOTO_API_URL}?cableId=${cableId}&fileName=${fileName}&user=${user}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}` 
        }
      });
  
      const result = await response.json();
      if (response.ok) {
        setUploadMessage(result.message);
        // Обновляем список изображений
        await loadCableUpdatingImagesFromServer(cableId, setServerImageUrls, setUploadMessage);
      } else {
        setUploadMessage('Ошибка удаления файла: ' + result.message);
      }
    } catch (error) {
      setUploadMessage('Ошибка удаления файла: ' + error.message);
    }
  };